import { TextLinkWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';
import { FormikCheckbox } from '../../../../commonInfra/components/FormikCheckbox';
import { HelpService } from '../../../../commonInfra/services/HelpService';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { SettingsSection } from '../../../components/common/SettingsSection';
import { learnMoreStyle } from '../../../styles/CommonStyles';
import { SiteSettingsForServerAdminProps } from '../site-settings/ReactSiteSettingsForServerAdmin';
import { componentRegistryEntry } from '../SettingsComponentRegistryFunctions';

export const CACHE_WARMUP_FIELD = 'settings.cacheWarmupEnabled';

export type CacheWarmupSectionProps = SiteSettingsForServerAdminProps<'cacheWarmupEnabled'>;

export function CacheWarmupSection(props: CacheWarmupSectionProps) {
  return FeatureFlags.cacheWarmup
    ? (
      <SettingsSection title={Messages.performanceEnhancements()}
                       testId={'cache-warmup-setting-section'}
                       description={renderDescription()}>

        <FormikCheckbox name={'settings.cacheWarmupEnabled'}
                        label={Messages.cacheWarmupCheckboxLabel()}
                        testId={'enable-cache-warmup-checkbox'}/>

      </SettingsSection>
    )

    : null;
}

function renderDescription() {
  return <>
    <span>{Messages.cacheWarmupDetails()}</span>
    <TextLinkWidget testId={'cache-warmup-learn-more'}
                    className={learnMoreStyle}
                    href={HelpService.getServerHelpUrlByCategory('workbookrefresh')}
                    target={'_blank'}>
      {Messages.cacheWarmupLearnMore()}
    </TextLinkWidget>
  </>;
}

export const CacheWarmupSectionSpecs = componentRegistryEntry({
  name: 'CacheWarmupSection',
  component: CacheWarmupSection
});
